/**
 * Authentication and User Types
 */

export type UserRole = 'admin' | 'pilot' | 'scheduler';

export interface User {
  id: number;
  username: string;
  email: string;
  firstName: string;
  lastName: string;
  role: UserRole;
  isActive?: boolean;
  // Pilot-specific fields (optional)
  baseRate?: number;
  overtimeRate?: number;
  shortNoticeRate?: number;
}

// Helper to get full name from user
export const getUserFullName = (user: User): string => {
  return `${user.firstName} ${user.lastName}`.trim();
};

export interface LoginRequest {
  username: string;
  password?: string;
  pin?: string;
}

export interface LoginResponse {
  token: string;
  user: User;
}

export interface AuthContextType {
  user: User | null;
  token: string | null;
  login: (credentials: LoginRequest) => Promise<void>;
  logout: () => void;
  isAuthenticated: boolean;
  isLoading: boolean;
}
